import React from 'react';
import { Quote } from 'lucide-react';

const PullQuote = ({ quote, author }) => {
  return (
    <section className="bg-cream py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-6 md:px-10 text-center reveal">
        <Quote className="mx-auto text-gold" size={30} strokeWidth={1.2} />
        <blockquote className="mt-6 font-serif-display italic text-navy text-3xl md:text-[2.4rem] leading-[1.2] font-medium">
          “{quote}”
        </blockquote>
        {author && (
          <div className="mt-6 chapter-badge text-gold uppercase">— {author}</div>
        )}
      </div>
    </section>
  );
};

export default PullQuote;
